import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import _EXT_Integrante from "../../Componentes/Compuestos/Complejos/Clientes/EXT_Integrante"
import { function_ABM_EEX_Clientes_LeerPorDNI } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import LogoN7 from '../../Img/LogoN7_FondoTransparente.png'
import LogoLatitudVirtual from '../../Img/LogoLV_FondoTransparente.png';
import { function_ABM_ZON_Plantas_Leer } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas";


export const _PCL_Login = () => {
  const { CodigoCompania, CodigoEmpresa = "E01", CodigoPlanta = "P01" } = useParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authError, setAuthError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [controlUsuarioVisible, setControlUsuarioVisible] = useState(true);
  const [controlPasswordVisible, setControlPasswordVisible] = useState(true);
  const [isValidParams, setIsValidParams] = useState(false);
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const valid = CodigoCompania &&
      CodigoCompania !== "null" &&
      CodigoCompania !== "undefined" &&
      CodigoCompania.trim() !== "";
    setIsValidParams(valid);

    localStorage.setItem("CodigoCompania", CodigoCompania);
    localStorage.setItem("CodigoEmpresa", CodigoEmpresa);
    localStorage.setItem("CodigoPlanta", CodigoPlanta);

    try {
      const defaultLogo = require(`../../Img/${CodigoCompania}/${CodigoEmpresa}/${CodigoPlanta}/logoFondoTransparente.png`);
      setLogo(defaultLogo);
    } catch (error) {
      const fallbackLogo = require(`../../Img/LogoLV_FondoTransparente.png`);
      setLogo(fallbackLogo);
    }

    const getData = async () => {
      const datosDocumento = await function_ABM_ZON_Plantas_Leer(CodigoPlanta)

      if (datosDocumento.data[0]?.Logo) {
        let mimeType = "image/jpeg"; // Valor por defecto

        // Detectar el formato a partir del encabezado de la cadena Base64
        if (datosDocumento.data[0].Logo.startsWith("/9j/")) mimeType = "image/jpeg";
        else if (datosDocumento.data[0].Logo.startsWith("iVBOR")) mimeType = "image/png";
        else if (datosDocumento.data[0].Logo.startsWith("R0lGOD")) mimeType = "image/gif";

        const logoUrl = `data:${mimeType};base64,${datosDocumento.data[0].Logo}`;
        setLogo(logoUrl);
      }
    }

    getData()
  }, [CodigoCompania]);

  if (!isValidParams) {
    return (
      <div style={{
        padding: '40px',
        textAlign: 'center',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#a94442',
        backgroundColor: '#f2dede',
        border: '1px solid #ebccd1',
        borderRadius: '8px',
        margin: '50px auto',
        maxWidth: '500px'
      }}>
        ⚠️ Compañía inválida. Verificá el enlace o contactá al soporte.
      </div>
    );
  }

  const handleSelectChange = (event) => {
    localStorage.setItem("Estilo", event.target.value);
  };

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault(); // Solo llamamos preventDefault si event es válido
    }
    setIsLoading(true);

    try {
      const resultUsuario = await function_ABM_EEX_Clientes_LeerPorDNI(email, password)

      if (Array.isArray(resultUsuario.data) && resultUsuario.data.length > 0) {
        const user = resultUsuario.data[0];
        localStorage.setItem("Terminal", 0);
        localStorage.setItem("IdCliente", user.IdCliente);
        localStorage.setItem("Cliente", user.RazonSocial);
        localStorage.setItem("isClienteLoggedIn", true);
        setRedirect(true);
      } else {
        localStorage.setItem("isClienteLoggedIn", false);
        setAuthError(true);
        setRedirect(false);
      }
    } catch (error) {
      alert("Error al validar el usuario:" + error);
      setAuthError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePwdChange = (event) => {
    setPassword(event.target.value);
  };

  if (redirect) {
    return <Navigate to="/PortalClientesDBPrincipal" />;
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#f0f2f5'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        display: 'flex',
        overflow: 'hidden',
        width: '600px',
        maxWidth: '90%'
      }}>
        {/* Logo Cliente */}
        <div style={{
          flex: '1',
          background: '#e9ecef',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px'
        }}>
          <img
            src={logo}
            alt="Logo Cliente"
            style={{ maxWidth: '100%', maxHeight: '150px' }}
          />
        </div>

        {/* Login */}
        <div style={{
          flex: '2',
          padding: '30px'
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '20px',
            fontWeight: 'bold',
            fontSize: '1.2rem'
          }}>
            PORTAL DE CLIENTES
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="inputEmail">D.N.I. o C.U.I.T. registrada</label>
              <input
                className={`form-control ${controlUsuarioVisible ? '' : 'd-none'} ${authError ? 'is-invalid' : ''}`}
                id="inputEmail"
                placeholder="D.N.I. o C.U.I.T."
                type="text"
                name="username"
                onChange={handleEmailChange}
                required={controlUsuarioVisible ? 'required' : undefined}
              />
              <div className="invalid-feedback">Es necesario ingresar un D.N.I. o C.U.I.T. válido previamente registrado.</div>
            </div>

            <div className="form-group">
              <label htmlFor="inputPassword">Contraseña</label>
              <input
                type="password"
                className={`form-control ${controlPasswordVisible ? '' : 'd-none'} ${authError ? 'is-invalid' : ''}`}
                id="inputPassword"
                placeholder="******"
                name="password"
                onChange={handlePwdChange}
                required={controlPasswordVisible ? 'required' : undefined}
              />
              <div className="invalid-feedback">Es necesario ingresar una contraseña válida.</div>
            </div>

            <div className="form-group">
              <button className="btn btn-primary btn-block" type="submit" disabled={isLoading}>
                INGRESAR&nbsp;&nbsp;
                {isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
              </button>
            </div>
          </form>
        </div>

        {/* Logo Neftis */}
        <div style={{
          flex: '1',
          background: '#e9ecef',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px'
        }}>
          <img
            src={LogoN7}
            alt="Logo Neftis"
            style={{ maxWidth: '100%', maxHeight: '150px' }}
          />
        </div>
      </div>
    </div>
  );
};
